module.exports = __webpack_public_path__ + "static/media/main idea.a0a57b08.mp3";